import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Flex,
  Input,
  useDisclosure
} from "@chakra-ui/react";
import axios from "axios";
import { toast } from "react-toastify";
import apiUrl from "variables/api";
import { FaSearch } from "react-icons/fa";
import ArchiveModal from "./ArchiveModal";

export default function ManageModal({
  isOpen,
  onClose,
  companyData,
  setCompanyData,
  actualCompany,
  setActualCompany,
  fetchCompanyData,
}) {
  const [newCompany, setNewCompany] = useState("");
  const [archivedCompanies, setArchivedCompanies] = useState([]);
  const [archiveData, setArchiveData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const {
    isOpen: isAddConfirmOpen,
    onOpen: onAddConfirmOpen,
    onClose: onAddConfirmClose,
  } = useDisclosure();
  const {
    isOpen: isEndConfirmOpen,
    onOpen: onEndConfirmOpen,
    onClose: onEndConfirmClose,
  } = useDisclosure();
  const {
    isOpen: isArchiveModalOpen,
    onOpen: onArchiveModalOpen,
    onClose: onArchiveModalClose,
  } = useDisclosure();

  useEffect(() => {
    if (isOpen) {
      axios
        .get(apiUrl + "/data/school/company/list", {
          headers: { "x-access-token": localStorage.getItem("token") },
        })
        .then((response) => {
          setArchivedCompanies(
            response.data.filter((company) => company.active === 0)
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [isOpen]);

  const handleAddCompany = () => {
    if (!newCompany) return;
    const lastCompany = companyData[companyData.length - 1] || { id: 0 };
    const newCompanyData = {
      startDate: newCompany,
      name: `KS${lastCompany.id}/${new Date(newCompany).getFullYear()}`,
      active: 1,
    };
    axios
      .post(apiUrl + "/data/school/company/create", newCompanyData, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        fetchCompanyData();
        onAddConfirmClose();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleEndCurrentCompany = () => {
    if (!actualCompany?.id) return;
    const endDate = new Date().toISOString().split("T")[0];
    axios
      .post(
        apiUrl + "/data/school/company/end",
        { companyID: actualCompany.id, endDate },
        {
          headers: { "x-access-token": localStorage.getItem("token") },
        }
      )
      .then((response) => {
        fetchCompanyData();
        onEndConfirmClose();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleArchiveOpen = async (companyId) => {
    try {
      const response = await axios.get(`${apiUrl}/data/school/company/details/${companyId}`, {
        headers: { "x-access-token": localStorage.getItem("token") },
      });
      setArchiveData(response.data);
      setSelectedCompany(companyId);
      onArchiveModalOpen();
    } catch (error) {
      console.error(error);
      toast.error("Napotkano błąd podczas pobierania danych kompanii");
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Zarządzanie kompaniami</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" gap="4">
              <Input
                type="date"
                placeholder="Nowa kompania"
                value={newCompany}
                onChange={(e) => setNewCompany(e.target.value)}
                required
              />
              <Button
                colorScheme="green"
                onClick={() => {
                  if (newCompany) {
                    onAddConfirmOpen();
                  } else {
                    toast.error("Wprowadź datę rozpoczęcia nowej kompanii");
                  }
                }}
                disabled={actualCompany?.id}
              >
                Dodaj nową kompanię
              </Button>
              <Button
              colorScheme="red"
              onClick={() => {
                if (actualCompany?.id) {
                  onEndConfirmOpen();
                } else {
                  toast.error("Brak aktywnej kompanii");
                }
              }
              }
              disabled={!actualCompany?.id}
              >
                Zakończ aktualną kompanię
              </Button>
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>Nazwa</Th>
                    <Th>Data rozpoczęcia</Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {companyData.map((company, index) => (
                    <Tr key={index}>
                      <Td>
                        KS{company.id}/
                        {new Date(company.startDate).getFullYear()}
                      </Td>
                      <Td>{company.startDate.split("T")[0]}</Td>
                      <Td>
                        <Button colorScheme="orange" onClick={() => handleArchiveOpen(company.id)}>
                          <FaSearch />
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Zamknij
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isAddConfirmOpen} onClose={onAddConfirmClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Potwierdzenie</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Czy na pewno chcesz dodać nową kompanię?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={onAddConfirmClose}>
              Anuluj
            </Button>
            <Button colorScheme="green" onClick={handleAddCompany}>
              Potwierdź
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isEndConfirmOpen} onClose={onEndConfirmClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Potwierdzenie</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Czy na pewno chcesz zakończyć aktualną kompanię?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={onEndConfirmClose}>
              Anuluj
            </Button>
            <Button colorScheme="green" onClick={handleEndCurrentCompany}>
              Potwierdź
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <ArchiveModal
        isOpen={isArchiveModalOpen}
        onClose={onArchiveModalClose}
        archiveData={archiveData}
      />
    </>
  );
}